<template>
    <div>
      <div class="mb-2">
        <a href="#" @click.prevent="$router.go(-1)" class="">
          <i class="bi bi-arrow-left-short icon-sm "></i> Go back
        </a>
      </div>

      <CCard class="rounded shadow-sm">
        <div class="application-details text-center mb-4 p-3 border-bottom">
        <h4 class="mb-3">{{ $route.query.hei }}</h4>
        
        <div class="row justify-content-center">
          <div class="col-md-4 mb-2">
            <span class="text-muted">Status: </span> 
            <span class="font-weight-bold">{{ $route.query.status }}</span>
          </div>
          <div class="col-md-4 mb-2">
            <span class="text-muted">Academic Year: </span> 
            <span class="font-weight-bold">{{ $route.query.academic_year }}</span>
          </div>
        </div>
        
        <div class="row justify-content-center">
          <div class="col-md-4 mb-2">
            <span class="text-muted">Contact Person: </span> 
            <span class="font-weight-bold">{{ $route.query.contact_person }}</span>
          </div>
          <div class="col-md-4 mb-2">
            <span class="text-muted">Phone: </span> 
            <span class="font-weight-bold">{{ $route.query.phone_no }}</span>
          </div>
        </div>
        
        <div class="mb-2">
          <span class="text-muted">Email: </span> 
          <span class="font-weight-bold">{{ $route.query.email }}</span>
        </div>
        
        <div class="mt-2">
          <span class="text-muted">Remarks: </span> 
          <span class="font-weight-bold">{{ $route.query.remarks || 'None' }}</span>
        </div>
        </div>
        <CCardBody>
          <div class="d-flex justify-content-start flex-wrap">
            <div class="col-md-3 col-12 pl-0 mb-2">
              <input
                type="search"
                class="form-control"
                placeholder="Try searching the data"
                v-model="searchValue"
              />
            </div>

            <div class="col-md-2 col-6 pl-md-2 pl-0 mb-2">
              <select v-model="selectedComplied" class="form-control">
                <option value="">All Complied Status</option>
                <option :value="1">Yes</option>
                <option :value="0">No</option>
              </select>
            </div>

            <div class="mb-2">
              <button
                class="btn btn-outline-secondary text-dark mr-2"
                @click="refreshData"
                :disabled="refreshLoader"
              >
                <i class="bi bi-arrow-clockwise mr-1"></i> Refresh
              </button>
              <div
                v-if="refreshLoader"
                class="spinner-border spinner-border-sm"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>

          <!-- Desktop table view -->
          <div class="table-responsive d-none d-md-block">
            <table class="table table-hover table-bordered table-sm mt-3">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Requirements</th>
                  <th>PDF File</th>
                  <th>EXCEL File</th>
                  <th>Updated File</th>
                  <th>Complied</th>
                  <th>Remarks</th>
                  <th>Date Created</th>
                  <th>Date Updated</th>
                  <th>Updated By</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center" v-if="!filteredList.length && !tableLoader">
                  <td colspan="11">No results found</td>
                </tr>
                <tr class="text-center" v-if="tableLoader">
                  <td colspan="11">
                    <div class="spinner-border spinner-border-sm mr-1"></div>
                    Loading
                  </td>
                </tr>
                <tr v-for="(requirement, index) in paginatedList" :key="requirement.id">
                  <th>{{ index + 1 }}</th>
                  <td>{{ requirement.description }}</td>
                  <td>
                      <a :href="prefix + requirement.path" target="_blank" rel="noopener noreferrer">
                          View File
                      </a>
                  </td>
                  <td>
                      <a 
                       v-if="requirement.excel_path"
                       :href="prefix + requirement.excel_path" target="_blank" rel="noopener noreferrer">
                          View File
                      </a>
                      <span v-else>No File</span>
                  </td>
                  <td>
                      <a 
                       v-if="requirement.updated_path"
                       :href="prefix + requirement.updated_path" target="_blank" rel="noopener noreferrer">
                          View File
                      </a>
                      <span v-else>No File</span><br>
                      <small v-if="requirement.updated_path">{{ requirement.file_updated_at | standardDate }}</small>
                  </td>
                  <td>{{ requirement.is_complied ? 'Yes' : 'No' }}</td>
                  <td>{{ requirement.remarks }}</td>
                  <td>
                    <span v-if="requirement.created_at">{{
                      requirement.created_at | standardDate
                    }}</span>
                  </td>
                  <td>
                    <span v-if="requirement.updated_at != requirement.created_at">{{
                      requirement.updated_at | standardDate
                    }}</span>
                  </td>
                  <td>{{ requirement.updated_by }}</td>
                  <td class="text-center">
                    <button 
                      class="btn btn-sm btn-outline-primary mr-1"
                      @click.stop="openUpdateModal(requirement)"
                      title="Update Status & Remarks"
                      :aria-label="`Update requirement ${index + 1}`"
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button 
                      class="btn btn-sm btn-outline-danger"
                      @click.stop="deleteRequirement(requirement)"
                      title="Delete Requirement"
                      :aria-label="`Delete requirement ${index + 1}`"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <!-- Mobile card view -->
          <div class="d-md-none">
            <div v-if="!filteredList.length && !tableLoader" class="text-center p-3">
              No results found
            </div>
            <div v-if="tableLoader" class="text-center p-3">
              <div class="spinner-border spinner-border-sm mr-1"></div>
              Loading
            </div>
            <div v-for="(requirement, index) in paginatedList" :key="requirement.id" class="card mb-3 shadow-sm">
              <div class="card-body p-3">
                <h5 class="card-title mb-3">{{ requirement.description }}</h5>
                
                <div class="row mb-2">
                  <div class="col-5 text-muted">PDF File:</div>
                  <div class="col-7">
                    <a :href="prefix + requirement.path" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-primary">
                      <i class="bi bi-file-earmark-pdf"></i> View
                    </a>
                  </div>
                </div>
                
                <div class="row mb-2" v-if="requirement.excel_path">
                  <div class="col-5 text-muted">Excel File:</div>
                  <div class="col-7">
                    <a :href="prefix + requirement.excel_path" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-success">
                      <i class="bi bi-file-earmark-excel"></i> View
                    </a>
                  </div>
                </div>
                
                <div class="row mb-2" v-if="requirement.updated_path">
                  <div class="col-5 text-muted">Updated File:</div>
                  <div class="col-7">
                    <a :href="prefix + requirement.updated_path" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-info">
                      <i class="bi bi-file-earmark-arrow-up"></i> View
                    </a>
                    <div><small>{{ requirement.file_updated_at | standardDate }}</small></div>
                  </div>
                </div>
                
                <div class="row mb-2">
                  <div class="col-5 text-muted">Complied:</div>
                  <div class="col-7">
                    <span :class="requirement.is_complied ? 'text-success' : 'text-danger'">
                      {{ requirement.is_complied ? 'Yes' : 'No' }}
                    </span>
                  </div>
                </div>
                
                <div class="row mb-3" v-if="requirement.remarks">
                  <div class="col-5 text-muted">Remarks:</div>
                  <div class="col-7">{{ requirement.remarks }}</div>
                </div>
                
                <div class="row mb-2">
                  <div class="col-5 text-muted">Date Created:</div>
                  <div class="col-7">{{ requirement.created_at | standardDate }}</div>
                </div>
                
                <div class="d-flex justify-content-end mt-3">
                  <button 
                    class="btn btn-sm btn-outline-primary mr-2"
                    @click.stop="openUpdateModal(requirement)"
                    title="Update Status & Remarks"
                  >
                    <i class="bi bi-pencil-square"></i> Update
                  </button>
                  <button 
                    class="btn btn-sm btn-outline-danger"
                    @click.stop="deleteRequirement(requirement)"
                    title="Delete Requirement"
                  >
                    <i class="bi bi-trash"></i> Delete
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="d-flex justify-content-between align-items-center flex-wrap mt-3">
            <div class="mb-2">
              <select v-model="perPage" class="form-control form-control-sm" style="width: 80px">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
            <div class="mb-2">
              <button 
                class="btn btn-sm btn-outline-secondary mr-2" 
                :disabled="currentPage === 1"
                @click="currentPage--"
              >
                Previous
              </button>
              <span class="mr-2">
                Page {{ currentPage }} of {{ totalPages }}
              </span>
              <button 
                class="btn btn-sm btn-outline-secondary" 
                :disabled="currentPage === totalPages || totalPages === 0"
                @click="currentPage++"
              >
                Next
              </button>
            </div>
          </div>
        </CCardBody>
      </CCard>

      <!-- Update the modal markup -->
      <div 
        class="modal fade" 
        id="updateModal" 
        role="dialog"
        tabindex="-1"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="updateModalLabel">Update Complied Status & Remarks</h5>
              <button 
                type="button" 
                class="close" 
                data-dismiss="modal"
                aria-label="Close"
                tabindex="0"
              >
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="compliedSelect">Complied</label>
                <select 
                  id="compliedSelect"
                  v-model="updateForm.is_complied" 
                  class="form-control"
                  tabindex="0"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div class="form-group">
                <label for="remarksTextarea">Remarks</label>
                <textarea 
                  id="remarksTextarea"
                  v-model="updateForm.remarks" 
                  class="form-control" 
                  rows="3"
                  tabindex="0"
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button 
                type="button" 
                class="btn btn-secondary" 
                data-dismiss="modal"
                tabindex="0"
              >
                Close
              </button>
              <button 
                type="button" 
                class="btn btn-primary" 
                @click="updateRequirement"
                :disabled="updating"
                tabindex="0"
              >
                {{ updating ? 'Updating...' : 'Save Changes' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TosfRequirements',
    components: {

    },
    data() {
      return {
        tableLoader: false,
        tosfLists: [],
        searchValue: '',
        refreshLoader: false,
        prefix: 'https://drive.google.com/file/d/',
        currentPage: 1,
        perPage: 10,
        selectedComplied: '',
        updating: false,
        updateForm: {
          id: '',
          is_complied: '',
          remarks: '',
        },
      }
    },
    computed: {
      filteredList() {
        if (!this.searchValue && this.selectedComplied === '') {
          return this.tosfLists;
        }
        
        return this.tosfLists.filter(requirement => {
          const matchesSearch = !this.searchValue || [
            requirement.description,
            requirement.filename,
            requirement.remarks
          ].some(field => 
            field?.toLowerCase().includes(this.searchValue.toLowerCase().trim())
          );

          const matchesComplied = this.selectedComplied === '' || 
            Number(requirement.is_complied) === this.selectedComplied;

          return matchesSearch && matchesComplied;
        });
      },
      paginatedList() {
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;
        return this.filteredList.slice(start, end);
      },
      totalPages() {
        return Math.ceil(this.filteredList.length / this.perPage);
      }
    },
    watch: {
      searchValue() {
        this.currentPage = 1;
      },
      selectedComplied() {
        this.currentPage = 1;
      },
      perPage() {
        this.currentPage = 1;
      }
    },
    methods: {
      previousRoute() {
        this.$router.go(-1);
      },
      refreshData() {
        this.refreshLoader = true;
        this.getTOSFRequirementsList();
      },
      getTOSFRequirementsList() {
        this.tableLoader = true;
        const id = this.$route.params.id;
        const type_increase = this.$route.query.type;
        
        axios
          .get(`api/tosf/application-requirements-list/${id}/${type_increase}`)
          .then((res) => {
            console.log("TOSF Requirements:", res.data);
            this.tosfLists = res.data;
            if (this.refreshLoader) {
              toastr.success('Data refreshed successfully');
            }
          })
          .catch((err) => {
            console.error('Error fetching TOSF list:', err);
            toastr.error('Failed to fetch data');
          })
          .finally(() => {
            this.tableLoader = false;
            this.refreshLoader = false;
          });
      },
      openUpdateModal(requirement) {
        this.updateForm.id = requirement.id;
        this.updateForm.is_complied = requirement.is_complied;
        this.updateForm.remarks = requirement.remarks;
        $('#updateModal').modal({
          backdrop: 'static',
          keyboard: false,
          focus: true
        });
      },
      updateRequirement() {
        this.updating = true;
        
        // Convert is_complied to boolean before sending to API
        const updateData = {
          ...this.updateForm,
          // is_complied: Boolean(this.updateForm.is_complied)
        };

        axios.put(`api/tosf/update-requirements/${this.updateForm.id}`, updateData)
          .then(response => {

            this.getTOSFRequirementsList();
            
            $('#updateModal').modal('hide');
            toastr.success('Requirement updated successfully');
          })
          .catch(error => {
            console.error('Error updating requirement:', error);
            toastr.error('Failed to update requirement');
          })
          .finally(() => {
            this.updating = false;
          });
      },
      deleteRequirement(requirement) {
        // Confirm deletion
        if (confirm(`Are you sure you want to delete the requirement: ${requirement.filename} file?`)) {
          axios
            .delete(`api/tosf/delete-requirements/${requirement.id}`)
            .then((response) => {
              console.log('Requirement deleted:', response.data);
              this.getTOSFRequirementsList();
              toastr.success('Requirement deleted successfully');
            })
            .catch((error) => {
              console.error('Error deleting requirement:', error);
              toastr.error('Failed to delete requirement');
            });
        } else {
          console.log('Deletion canceled');
        }
      }
    },
    mounted() {
      this.getTOSFRequirementsList();
    },
  };
  </script>
  
<style scoped>
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

table tr {
  cursor: pointer !important;
}

.bi-arrow-clockwise,
.bi-arrow-left-short {
  font-size: 1rem;
}

/* Mobile styles */
@media (max-width: 767.98px) {
  .card {
    border-radius: 0.25rem;
  }
  
  .application-details {
    padding: 1rem 0.5rem !important;
  }
  
  .application-details h4 {
    font-size: 1.25rem;
  }
  
  /* Filter controls for mobile */
  .d-flex.justify-content-start {
    margin-bottom: 0.5rem;
  }
}

/* Card hover effect */
.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  transition: box-shadow 0.3s ease-in-out;
}
</style>
  